module.exports = "varying vec3 vPosition;\nvarying vec3 vNormal;\nvarying vec2 vUV;\n#ifdef ATTRIBUTE_TANGENT_ENABLED\nvarying vec3 vTangent;\n#endif\n#ifdef ATTRIBUTE_COLOR_0_ENABLED\nvarying vec3 vVertexColor;\n#endif"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/Shaders/gltf-varying.glsl
// module id = 42
// module chunks = 0